import { connect } from 'react-redux';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { getIsUserDropdownOpen } from '../redux/selectors';
import { closeNotificationsDropdown } from '../redux/actions';
const mapStateToProps = (state)=>({
        isLoggedIn: getIsLoggedIn(state),
        isUserDropdownOpen: getIsUserDropdownOpen(state)
    });
const mapDispatchToProps = {
    closeNotificationsDropdown
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=SiteHeaderMobile.container.js.map